import React from 'react';
import { useI18next } from 'gatsby-plugin-react-i18next';

import QueryStringNavigate from '../QueryStringNavigate';

import * as S from './Footer.styled';
import { WhatsAppIcon } from '../Icons';

const WhatsAppContact = () => {
  const { language } = useI18next();
  return (
    <S.WhatsAppContact>
      <S.WhatsAppNumber>
        <QueryStringNavigate
          languageChange={language}
          path="https://wa.me/+34623560332/"
          id="whatsAppContact"
        >
          <WhatsAppIcon /> WhatsApp: 623 560 332
        </QueryStringNavigate>
      </S.WhatsAppNumber>
    </S.WhatsAppContact>
  );
};

WhatsAppContact.displayName = 'WhatsAppContact';
export default WhatsAppContact;
